import axiosInstance from "../axiosInstance";
import API_ROUTES from "../apiRoutes";

export const AuthAPI = {
  login: (data) => axiosInstance.post(API_ROUTES.AUTH.LOGIN, data),
  changePassword: (data) =>
    axiosInstance.post(API_ROUTES.AUTH.CHANGE_PASSWORD, data),
  updateProfile: (data) => axiosInstance.post(API_ROUTES.AUTH.UPDATE, data),
  getProfile: () => axiosInstance.get(API_ROUTES.AUTH.GET_PROFILE),
};
